import Vue from "vue";
import VueI18n from "vue-i18n";

import ElementUI from "element-ui";
import zhLocale from "element-ui/lib/locale/lang/zh-CN";
import enLocale from "element-ui/lib/locale/lang/en";

import zhCN from "./lang/zh-CN";
import en from "./lang/en";

Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: localStorage.getItem("lang") || "zh-CN",
  messages: {
    "zh-CN": {
      ...zhCN,
      ...zhLocale,
    },
    en: {
      ...en,
      ...enLocale,
    },
  },
});

// ---- 修复 Element UI aria-hidden 警告 ----
// Element UI 2.x 的原生控件 input（radio/checkbox/switch）硬编码 aria-hidden="true"，
// 当键盘方向键在同组控件间移动焦点时，焦点落在 aria-hidden 元素上，浏览器会报
// "Blocked aria-hidden on an element because its descendant retained focus" 警告。
// 通过包装各组件 render 函数，在创建元素时移除该属性，不影响组件其它行为。
// 注意：必须在 Vue.use(ElementUI) 之前执行，因为 use 内部会 Vue.extend 快照 render。
const removeAriaHidden = (Component) => {
  if (!Component || typeof Component.render !== "function") return;
  const originalRender = Component.render;
  Component.render = function (h) {
    const patchedH = (tag, data, ...rest) => {
      if (data && data.attrs && data.attrs["aria-hidden"] !== undefined) {
        data.attrs = { ...data.attrs };
        delete data.attrs["aria-hidden"];
      }
      return h(tag, data, ...rest);
    };
    return originalRender.call(this, patchedH);
  };
};

[ElementUI.Radio, ElementUI.RadioButton, ElementUI.Checkbox, ElementUI.Switch].forEach(removeAriaHidden);

Vue.use(ElementUI, {
  size: "small",
  i18n: (key, value) => i18n.t(key, value),
});

export default i18n;
